import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import './mushroom.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Agra() {
    const [numPages, setNumPages] = useState(null);
    const [pageWidth, setPageWidth] = useState(600);
    const containerRef = useRef(null);

    useEffect(() => {
        function updateWidth() {
            if (containerRef.current) {
                setPageWidth(Math.min(containerRef.current.offsetWidth, 600));
            }
        }
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <div>
            <Navbar />
            <div className="product-content" ref={containerRef}>
                <Document
                    file={process.env.PUBLIC_URL + '/machines-pdfs/mushroom_farm_agra.pdf'}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            width={pageWidth}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            className="slideImg"
                        />
                    ))}
                </Document>
            </div>
            <Footer />
        </div>
    );
}

export default Agra; 